export enum ProspectSearchMode {
  PRECISE = "precise",
  BROAD = "broad",
}

export enum ProspectCriteriaField {
  TARGET_ROLES = "targetRoles",
  TARGET_SENIORITIES = "targetSeniorities",
  TARGET_FUNCTIONS = "targetFunctions",
  TARGET_INDUSTRIES = "targetIndustries",
  TARGET_BUSINESS_MODELS = "targetBusinessModels",
  TARGET_COMPANY_STAGES = "targetCompanyStages",
  TARGET_COMPANY_SIZES = "targetCompanySizes",
  TARGET_TECHNOLOGIES = "targetTechnologies",
  TARGET_COMPANIES = "targetCompanies",
  TARGET_LOCATIONS = "targetLocations",
  SEARCH_KEYWORDS = "searchKeywords",
  SEARCH_QUERIES = "searchQueries",
  MUST_HAVE_SIGNALS = "mustHaveSignals",
  PREFERRED_SIGNALS = "preferredSignals",
  PAIN_SIGNALS = "painSignals",
  TRIGGER_SIGNALS = "triggerSignals",
  TRUST_SIGNALS = "trustSignals",
  EXCLUDE_SIGNALS = "excludeSignals",
  EXCLUDE_KEYWORDS = "excludeKeywords",
  EXCLUDE_COMPANIES = "excludeCompanies",
  RECOMMENDED_PLATFORMS = "recommendedPlatforms",
}

export type ProspectSearchCriteria = {
  title: string;
  searchMode: ProspectSearchMode;
} & Record<ProspectCriteriaField, string[]>;

export function hasCriteriaContent(criteria: ProspectSearchCriteria | null | undefined): boolean {
  if (!criteria) {
    return false;
  }
  return Object.values(ProspectCriteriaField).some((field) => (criteria[field]?.length ?? 0) > 0);
}
